import React, { FC, useContext } from 'react';
import { NavPrivate } from './NavPrivate';
import { NavPublic } from './NavPublic';
import { NavMarketing } from './NavMarketing';
import { UserContext } from '../user/UserContext';

export const Navigation: FC = () => {
  const { loggedIn, currentUser, accessPremium } = useContext(UserContext);
  return (
    <nav className="nav__header">
      <div className="nav__group">
        {loggedIn && (
          <NavPrivate currentUser={currentUser} accessPremium={accessPremium} />
        )}
        {!loggedIn && <NavPublic />}
        <NavMarketing />
      </div>
    </nav>
  );
};
